import { render, staticRenderFns } from "./turara.vue?vue&type=template&id=1e13e21c&"
import script from "./turara.vue?vue&type=script&lang=js&"
export * from "./turara.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports